import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1094a788"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "col-10 col-lg-4 p-3 bg-light custom-modal m-auto rounded-3 mt-5" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"row pt-3\" data-v-1094a788><div class=\"col\" data-v-1094a788><h5 class=\"big-emoji pb-0 mb-0 pt-3\" data-v-1094a788>🎉</h5></div></div><div class=\"row pt-3\" data-v-1094a788><div class=\"col mx-2 text-center\" data-v-1094a788><p data-v-1094a788>Victoire! Votre mot de passe a bien été mis à jour!</p></div></div>", 2)
const _hoisted_4 = { class: "row text-start" }
const _hoisted_5 = { class: "col m-2" }
const _hoisted_6 = { class: "col form-group text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "backdrop",
    onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)), ["self"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("button", {
              class: "btn btn-primary",
              type: "button",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
            }, " Se connecter ")
          ])
        ])
      ])
    ])
  ]))
}